const getEmailShareUrl = () => (
  'mailto:?subject='
);

const getFacebookShareUrl = () => (
  'https://www.facebook.com/sharer/sharer.php?u='
);

const getPinterestShareUrl = () => (
  'https://pinterest.com/pin/create/button/?url='
);

const getTwitterShareUrl = () => (
  'https://twitter.com/intent/tweet?text='
);

const getAssetSharingHtml = (options) => {
  const {
    shareLink,
    description,
    src,
  } = options;
  return `
  <div class="heading-xxs mb-0">Share Photo</div>
  <ul class="image-caption list-unstyled d-flex flex-row flex-wrap pt-0 mb-0">
    <li class="me-3">
      <a href="${getFacebookShareUrl()}${shareLink}" class="share-fb-link link link-underline" title="Facebook" id="share-fb" target="_blank" rel="noopener noreferrer">Facebook</a>
    </li>
    <li class="me-3">
      <a href="${getTwitterShareUrl()}Check out this photo from the Bali Blinds Design Gallery&url=${shareLink}" title="Twitter" class="share-tw-link link link-underline" id="share-tw" target="_blank" rel="noopener noreferrer">Twitter</a>
    </li>
    <li class="me-3">
      <a href="${getPinterestShareUrl()}${shareLink}&media=${src}&description=${description}" title="Pinterest" class="share-pt-link link link-underline" id="share-pt" target="_blank" rel="noopener noreferrer">Pinterest</a>
    </li>
    <li>
      <a href="${getEmailShareUrl()}Check%20out%20this%20photo%20from%20the%20Bali%20Blinds%20Design%20Gallery&body=Photo%20link%3A%20${shareLink}%0A%0AAbout%20this%20photo%3A%20'${description}" title="Email" class="share-em-link link link-underline" id="share-em" target="_blank" rel="noopener noreferrer">Email</a>
    </li>
  </ul>`;
};

export {
  getEmailShareUrl,
  getFacebookShareUrl,
  getPinterestShareUrl,
  getTwitterShareUrl,
  getAssetSharingHtml,
};
